const getters = {
    saveConfiguration:      state => state.saveConfigurations,
    getConfiguration:       state => state.getConfigurations.length > 0 ? state.getConfigurations[0] : [],
    editConfiguration:      state => state.editConfigurations,
    hasErrorConfiguration:  state => state.hasErrorConfiguration,
}

export default getters